import { reactive, toRefs, onMounted, nextTick, onUnmounted } from 'vue'

import { checkNotifications, checkEWNotifications } from '@/util/order/tool'

export default function useContractServiceDealFn() {
  const state = reactive({
    showPopUp: 0,
    showUserPopUp: 0,
    contractData: {},
    notificationsTemp: {
      day: '16',
      effectiveMonth: 5,
      fin: 'LE42050421L193953',
      month: '3',
      notificationFile: 'https://www.jiaozhu.xyz/oss/vue2/img/1.png',
      notificationName: 'XXXX告知书1',
      year: '2022',
      contactName: 'contactName'
    }
  })

  const viewContractServiceDealFn = data => {
    let notificationsRes = checkNotifications(data)
    if (notificationsRes) {
      state.contractData = notificationsRes
      nextTick(() => {
        state.showPopUp += 1
      })
    }
  }

  const viewEWContractServiceDealFn = data => {
    const notificationsRes = checkEWNotifications(data)
    console.log('viewEWContractServiceDealFn notificationsRes', notificationsRes)
    if (notificationsRes) {
      state.contractData = notificationsRes
      nextTick(() => {
        state.showPopUp += 1
      })
    }
  }

  const viewContractUserDealFn = data => {
    state.contractData = data
    nextTick(() => {
      state.showUserPopUp += 1
    })
  }

  const setVal = (key, val) => {
    try {
      state[key] && (state[key] = val)
    } catch (error) {
      console.error('setVal error', error)
    }
  }

  onMounted(async () => {})

  onUnmounted(() => {
    document.body.style = 'font-size:12px;'
  })

  return {
    ...toRefs(state),
    setVal,
    viewContractServiceDealFn,
    viewEWContractServiceDealFn,
    viewContractUserDealFn
  }
}
